import MouseFollower from "mouse-follower";
import gsap from "gsap";

MouseFollower.registerGSAP(gsap);


export const cursor = () => {
	follower()
	// pointers()
	// magneticButtons()
}

const follower = () => {

	if (window.innerWidth < 782) return

	const cursor = new MouseFollower({
		container: document.body,
		speed: 0.1,
	})

	let els = document.querySelectorAll('a, .gform_button, select, [data-cursor="pointer"]')

	els.forEach(el => {

		el.addEventListener('mouseenter', () => {
			cursor.addState('-pointer')
		})

		el.addEventListener('mouseleave', () => {
			cursor.removeState('-pointer')
		})
	})
}




let magneticElements = []

const pointers = () => {

	let cursor = document.querySelector('.cursor')

	if (!cursor) return

	let mouseX = 0,
		mouseY = 0,
		cursorX = 0,
		cursorY = 0

	document.addEventListener('mousemove', (e) => {
		mouseX = e.clientX
		mouseY = e.clientY
	})

	function animate() {
		cursorX += (mouseX - cursorX) * 0.6
		cursorY += (mouseY - cursorY) * 0.6
		cursor.style.left = `${cursorX}px`
		cursor.style.top = `${cursorY}px`
		requestAnimationFrame(animate)
	}

	animate()

	document.addEventListener('mouseover', (e) => {
		const target = e.target.closest('a, .gform_button, select, [data-cursor="pointer"]')
		if (target) {
			cursor.classList.add('pointer')
		}
	})

	document.addEventListener('mouseout', (e) => {
		const target = e.target.closest('a, .gform_button, select, [data-cursor="pointer"]')
		if (target) {
			cursor.classList.remove('pointer')
		}
	})
}

export const magneticButtons = () => {

	magneticElements = []

	const buttons = document.querySelectorAll('[data-magnetic], .gform_button')

	buttons.forEach(button => {
		let lastDeltaX = 0
		let lastDeltaY = 0

		const handleMouseMove = (e) => {
			const rect = button.getBoundingClientRect()
			const btnX = rect.left + rect.width / 2
			const btnY = rect.top + rect.height / 2

			const deltaX = e.clientX - btnX
			const deltaY = e.clientY - btnY

			lastDeltaX = deltaX
			lastDeltaY = deltaY

			const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2)
			const scale = Math.max(1, 1.05 - (distance / 400))

			button.style.transform = `scale(${scale}) translate(${deltaX / 6}px, ${deltaY / 6}px) rotateX(${deltaY / 12}deg) rotateY(${deltaX / 12}deg)`
		}

		const handleMouseLeave = () => {
			const swing = [
				{ transform: `translate(${lastDeltaX / 6}px, ${lastDeltaY / 6}px) rotateX(${lastDeltaY / 12}deg) rotateY(${lastDeltaX / 12}deg) scale(1)` },
				{ transform: 'translate(0, 0) rotateX(0) rotateY(0) scale(1)' }
			]

			button.animate(swing, {
				duration: 500,
				easing: 'ease-out'
			})

			button.style.transform = 'scale(1)'
		}

		const handleMouseDown = () => {
			button.style.transition = 'transform 0.1s ease'
			button.style.transform += ' scale(1.02)'
		}

		const handleMouseUp = () => {
			button.style.transform = 'scale(1)'
		}

		// Attach
		button.addEventListener('mousemove', handleMouseMove)
		button.addEventListener('mouseleave', handleMouseLeave)
		button.addEventListener('mousedown', handleMouseDown)
		button.addEventListener('mouseup', handleMouseUp)

		// Save references for removal
		magneticElements.push({
			el: button,
			handlers: {
				mousemove: handleMouseMove,
				mouseleave: handleMouseLeave,
				mousedown: handleMouseDown,
				mouseup: handleMouseUp,
			}
		})
	})
}

export const reset = () => {
	if (magneticElements) {
		magneticElements.forEach(({ el, handlers }) => {
			el.removeEventListener('mousemove', handlers.mousemove)
			el.removeEventListener('mouseleave', handlers.mouseleave)
			el.removeEventListener('mousedown', handlers.mousedown)
			el.removeEventListener('mouseup', handlers.mouseup)
		})
		magneticElements = []
	}
	setTimeout(() => {
		magneticButtons()
	}, 2000);
}

export default () => { }